import { css } from 'styled-components';
export const rootMargin = '0px 0px -20% 0px';
export const cubicEaseOut = `cubic-bezier(0.33, 1, 0.68, 1)`;
export const shouldAnimate = (innerCss) => {
    return css `
    @media (prefers-reduced-motion: no-preference) {
      ${innerCss}
    }
  `;
};
export const transition = (properties, duration = 0.35, timing = cubicEaseOut) => {
    return shouldAnimate(css `
    transition-duration: ${typeof duration === 'string' ? duration : `${duration}s`};
    transition-property: ${properties};
    transition-timing-function: ${timing};
    will-change: ${properties};
  `);
};
